import React, { useEffect, useState } from "react";
import GroupedBarChart from "../../../CHARTS/GroupedBarChart";
const CommodityCHWightWiseChart = ({ data }) => {
  const [chartData, setChartData] = useState(null);

  function transformData(data) {
    const allMonthKeys = new Set();
    const groupMap = {};

    data.forEach((yearEntry) => {
      const year = yearEntry.F_YEAR;

      yearEntry.commodities_data.forEach((group) => {
        const groupKey = `${group.GROUP_COMMODITY}`;
        if (!groupMap[groupKey]) groupMap[groupKey] = { product: groupKey };

        const monthlyTargets = {}; // Track month-wise targets

        group.group_commodities_data.forEach((subGroup) => {
          subGroup.sub_commodities_data.forEach((commodity) => {
            commodity.months_data.forEach((monthEntry) => {
              const monthKey = `${monthEntry.A_MONTH}${year}`;
              const targetKey = `${monthKey} target`;
              allMonthKeys.add(monthKey);
              allMonthKeys.add(targetKey);

              // --- CH_WEIGHT sum ---
              const CH_WEIGHTSum = monthEntry.data.reduce(
                (sum, d) => sum + parseFloat(d.CH_WEIGHT || 0),
                0
              );
              groupMap[groupKey][monthKey] = (
                parseFloat(groupMap[groupKey][monthKey] || 0) + CH_WEIGHTSum
              ).toFixed(2);

              // --- Unique FROM_STN → TGT_CH_WEIGHT sum ---
              const fromStnSet = new Set();
              let targetSum = 0;
              for (const d of monthEntry.data) {
                if (!fromStnSet.has(d.FROM_STN)) {
                  fromStnSet.add(d.FROM_STN);
                  targetSum += parseFloat(d.TGT_CH_WEIGHT || 0);
                }
              }

              groupMap[groupKey][targetKey] = (
                parseFloat(groupMap[groupKey][targetKey] || 0) + targetSum
              ).toFixed(2);
            });
          });
        });
      });
    });

    const dimensions = ["product", ...Array.from(allMonthKeys).sort()];
    const series = Object.values(groupMap);

    return { dimensions, series };
  }

  useEffect(() => {
    if (data) {
      let calChartData = transformData(data);
      setChartData(calChartData);
    }
  }, [data]);
  return (
    <div>
      {chartData ? (
        <GroupedBarChart
          data={chartData}
          // yearDif={yearDif}
          from={"7ALoading"}
          chartType={"bar"}
        />
      ) : (
        "No Data Found"
      )}
    </div>
  );
};
export default CommodityCHWightWiseChart;
